var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img-no_studies") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 60,
    cy: 60,
    r: 60
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 36,
    cy: 36,
    r: 36
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.0.1-study---overview---empty",
    transform: "translate(-580.000000, -279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(24.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img-no_studies",
    transform: "translate(556.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    fill: "#F0F9FA",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 20,
    y: 32,
    width: 80,
    height: 88,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D6D6",
    mask: "url(#mask-2)",
    x: 36,
    y: 81,
    width: 48,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D6D6",
    mask: "url(#mask-2)",
    x: 36,
    y: 58,
    width: 54,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#E8E8E8",
    mask: "url(#mask-2)",
    x: 36,
    y: 90,
    width: 48,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#E8E8E8",
    mask: "url(#mask-2)",
    x: 36,
    y: 99,
    width: 32,
    height: 4,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass",
    transform: "translate(0.665476, 22.807612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-72",
    transform: "translate(12.334524, 0.192388)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    fill: "#DAF1F7",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1753887,18.0522326 C40.0410675,15.4524397 43.60837,15.3053515 44.7314574,17.7102304 L44.829429,17.9431672 L50.662,33.4403388 L70,33.4414947 C71.5815427,33.4414947 72.8772477,34.6652985 72.9917714,36.2175719 L73,36.441463 C73,38.022989 71.7761833,39.3186803 70.2238935,39.4332028 L70,39.4414313 L48.5869222,39.4414313 C47.4210215,39.4414313 46.3690028,38.767143 45.8761312,37.7267255 L45.7792365,37.4982872 L42.1945,27.9743966 L34.8788065,49.9474331 C34.0738278,52.3649326 30.8470502,52.7166009 29.5134096,50.6302996 L29.3904023,50.4207763 L23.4835,39.4402753 L4,39.4414313 C2.41845731,39.4414313 1.12275232,38.2176276 1.0082286,36.6653542 L1,36.441463 C1,34.8599371 2.22381669,33.5642458 3.77610648,33.4497233 L4,33.4414947 L25.2775157,33.4414947 C26.2967117,33.4414947 27.2398684,33.9582661 27.7903177,34.8025707 L27.9195654,35.020361 L31.381,41.456254 L39.1753887,18.0522326 Z",
    id: "Path",
    fill: "#9DD3E3",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1C255C",
    transform: "translate(16.000000, 68.526912) rotate(-315.000000) translate(-16.000000, -68.526912) ",
    x: 10,
    y: 52.5269119,
    width: 12,
    height: 32,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5269119,-3.63797881e-12 C68.4091629,-3.63797881e-12 84.5269119,16.117749 84.5269119,36 C84.5269119,55.882251 68.4091629,72 48.5269119,72 C28.6446609,72 12.5269119,55.882251 12.5269119,36 C12.5269119,16.117749 28.6446609,-3.63797881e-12 48.5269119,-3.63797881e-12 Z M48.5269119,8 C33.0629389,8 20.5269119,20.536027 20.5269119,36 C20.5269119,51.463973 33.0629389,64 48.5269119,64 C63.9908849,64 76.5269119,51.463973 76.5269119,36 C76.5269119,20.536027 63.9908849,8 48.5269119,8 Z",
    id: "Combined-Shape",
    fill: "#1D4C84",
    transform: "translate(48.526912, 36.000000) rotate(-630.000000) translate(-48.526912, -36.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.e81490e8cc2941a1e5c48052625a1fdd.svg";
export { ForwardRef as ReactComponent };